<app-shared-threats mode="GROUP" [values]="threats" />
